<template>
  <!-- 领取鲜奶卡 -->
  <div class="card_recive">
    <div class="font18 font_weight500 colo087 card_title">
      <div>领取礼品卡</div>
      <img
        src="@/assets/mine/icon_close@2x.png"
        alt=""
        class="close_img"
        @click="close"
      />
    </div>
    <div class="">
      <img src="@/assets/mine/card_card.png" alt="" class="title_img" />
      <div class="bg_bg">
        <div class="font16 font_weight400 line_height_22 rec_tit">
          “{{ queryCardVoucherUserByIdNoUserId.voucherName }}”
        </div>
        <div class="card_img">
          <img :src="queryCardVoucherUserByIdNoUserId.detailImg" alt="" />
        </div>
        <div class="recive_now" @click="reciveNow">立即领取</div>
        <!-- <img src="@/assets/mine/bg2.png" alt="" class="bg2_img" /> -->
        <!-- <img src="@/assets/mine/bg1.png" alt="" class="bg1_img" /> -->
      </div>
      <!-- <img src="@/assets/mine/bg_azlogo@2x.png" alt="" class="logo_img" /> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "ReceiveCard",
  data() {
    return {};
  },
  computed: {
    queryCardVoucherUserByIdNoUserId() {
      return this.$store.getters.queryCardVoucherUserByIdNoUserId;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store
        .dispatch("order/queryCardVoucherUserByIdNoUserId", {
          params: {
            id: this.$route.query.voucherUserId
          }
        })
        .then(() => {})
        .catch(err => {
          this.errorMsg = err.message;
        });
    },
    reciveNow() {
      // presentCardVoucherUser
      this.$store
        .dispatch("order/presentCardVoucherUser", {
          params: {
            voucherUserId: this.$route.query.voucherUserId,
            userId: this.$route.query.userId
          }
        })
        .then(() => {
          this.$router.push("/mine/cardpackagelist");
        })
        .catch(() => {});
    },
    close() {
      // this.$router.push("/mine/cardpackagelist");
      this.$router.push("/home");
    }
  }
};
</script>

<style lang="less" scoped>
.card_recive {
  background: linear-gradient(180deg, #00145e 0%, #000930 100%);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .card_title {
    height: 48px;
    line-height: 48px;
    background: #fff;
  }
  .title_img {
    width: 160px;
    display: block;
    margin: 20px auto 0;
  }
  .bg_bg {
    position: relative;
    margin: 24px 20px 0;
    background-image: url("../../../assets/mine/bg2x.png");
    background-size: 115% 100%;
    background-repeat: no-repeat;
    background-position: center;
    height: 430px;
    .rec_tit {
      color: #78482f;
      padding-top: 40px;
    }
    .card_img {
      width: 240px;
      max-height: 160px;
      margin: 0 auto;
      padding-top: 26px;
      img {
        width: 100%;
      }
    }
    .recive_now {
      font-size: 15px;
      font-weight: 500;
      color: #78482f;
      line-height: 20px;
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
      background: linear-gradient(180deg, #f7dfc4 0%, #dbb293 100%);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      border-radius: 22px;
      padding: 10px 52px;
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .close_img {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 12px;
    right: 12px;
  }
  // .logo_img {
  //   width: 93px;
  //   display: block;
  //   position: absolute;
  //   bottom: 24px;
  //   left: 50%;
  //   transform: translateX(-50%);
  // }
}
</style>
